import { render, staticRenderFns } from "./TabelaValoresMT.vue?vue&type=template&id=f485923e"
import script from "./TabelaValoresMT.vue?vue&type=script&lang=js"
export * from "./TabelaValoresMT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports